export enum FormMessages {
  required = 'Field is required',
  email = 'Email should be valid',
  min = 'Min: ${min}',
  stateEx = 'e.g NY',
  max = 'Max: ${max}',
  length = 'Length: ${length}',
  numeric = 'Must be numeric',
  true = 'Field must be true',
}
